export enum WorkProgressStateEnum {
  NotSet = 0,
  New = 1,
  InProgress = 2,
  VolumePresented = 3,
  ContractCreated = 4,
  ContractSent = 5,
  ContractSigned = 6,
  Completed = 7,
  Submitted = 8
}


export enum VolumeTypeEnum {
  NotSet = 0,
  Forecast = 1,
  Consumption = 2,
  Secured = 3,
  InProgress = 4,
}

export interface MonthDetail {
  Month: number;
  Quantity: number;
  VolumeType: VolumeTypeEnum;
}

export interface QuarterVolume {
  Year: number;
  Quarter: number;
  VolumeType: VolumeTypeEnum;
  Quantity: number;
  MonthDetails?: MonthDetail[];
}

export interface SecureVolumeWorkContainer {
  SecureVolumes: SecureVolumeContainer[];
  WorkProgressState: WorkProgressStateEnum;
}

export interface SecureVolumeContainer {
  CustomerBillingPointNo: number;
  BillingPointId: number;
  Address: string;
  /** Målåret (året man handlar för) – kommer alltid från backend, räkna aldrig själv */
  TargetYear: number;
  /** Volymsäkringsproduktens nummer i CRM – alltid ifyllt, även för gamla ärenden */
  ProductNo: number;
  QuarterVolumes: QuarterVolume[];
  WorkProgressState: WorkProgressStateEnum;
}

export interface SecureVolumeContractInfo {
  CustomerContractNo: number;
  CustomerBillingPointNo: number;
}

export interface SaveSecureVolumeRequest {
  customerNo: number;
  workId: number;
  body: {
    BillingPointId: number;
    QuarterVolumes: QuarterVolume[];
  };
}

/** Volymsäkringsprodukt från GET securevolume/products */
export interface SecureVolumeProduct {
  productNo: number;
  productName: string;
  managementLengthMonths: number;
  managementStartMonth: number;
  managementStartDay: number;
  managementPeriodStart: string;
  managementPeriodEnd: string;
  /** Året man handlar för – härlett av backend från förvaltningsperioden */
  defaultTargetYear: number;
}

export interface PopulateSecureVolumeResponse {
  createdWorks: number;
  createdEventData: number;
  totalCustomers: number;
  productNo: number;
  targetYear: number;
}

/** Ärende för ett annat målår än det listan visar – öppnas med samma work/pdf-anrop */
export interface SecureVolumePreviousWork {
  WorkNo: number;
  TargetYear: number;
  ProductNo: number;
  WorkProgressState: WorkProgressStateEnum;
}

export interface SecureVolumeCustomerListItem {
  CustomerNo: number;
  ProductNo: number;
  /** Målåret som WorkNo/WorkProgressState avser */
  TargetYear: number;
  /** Övriga års ärenden för kunden (historik) */
  PreviousWorks: SecureVolumePreviousWork[];
  CustomerId: string | null;
  CustomerName: string | null;
  HasExistingWork: boolean;
  WorkNo: number | null;
  AssignedToId: number | null;
  AssignedTo: { Id: number; Name: string } | null;
  WorkProgressState: WorkProgressStateEnum;
  HasWorkItem: boolean;
  HasFollowUp: boolean;
  ScheduledTo: string | null;
  Contracts: SecureVolumeContractInfo[];
}
